import React from "react";
import "./Loading.css";

const Loading = ({ text = "Ładowanie..." }) => {
  return (
    <div className="loading-inn-overlay">
      <div className="loading-inn-spinner" />
      <div className="loading-inn-text">{text}</div>
    </div>
  );
};

export default Loading;
